import { buildApiUrl } from './config';

export async function apiRequest<T = any>(
  method: string,
  url: string,
  data?: unknown,
  customConfig: RequestInit = {}
): Promise<T> {
  // Add link code header if present
  const linkCode = typeof window !== 'undefined' ? sessionStorage.getItem('staymiddle_link_code') : null;
  let headers: HeadersInit = {
    ...(linkCode ? { "X-StayMiddle-Link-Code": linkCode } : {}),
    ...(customConfig.headers || {}),
  };

  let body: any = undefined;
  // If data is FormData, do not set Content-Type header (browser will set it)
  if (data instanceof FormData) {
    body = data;
  } else if (data) {
    headers = { ...headers, "Content-Type": "application/json" };
    body = JSON.stringify(data);
  }

  const fullUrl = url.startsWith('http') ? url : buildApiUrl(url);

  const config: RequestInit = {
    method,
    headers,
    credentials: "include",
    ...customConfig,
    body,
  };

  try {
    const response = await fetch(fullUrl, config);
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('text/calendar')) {
      // For iCal export, return text directly
      const text = await response.text();
      if (!response.ok) {
        throw new Error(text || response.statusText);
      }
      return text as any;
    }
    let data;
    let isJson = false;
    try {
      data = await response.json();
      isJson = true;
    } catch (jsonErr) {
      // Not valid JSON, fallback to text
      if(data)
     return data 
    }
    console.log('API response:', response);
    if (!response.ok) {
      const errorMessage = isJson && data && data.message ? data.message : response.statusText;
      throw new Error(errorMessage);
    }
    return data;
  } catch (error) {
    console.error("API request error:", error);
    throw error;
  }
}
